import { AgentGrounding, AgentStatus } from '@d-id/types';

/**
 * This function aligns with server logic, changes here should be reflected there as well
 */
export const getDefaultTemperature = (template: AgentGrounding) => {
    switch (template) {
        case 'rag-grounded':
            return 0.1;
        case 'rag-ungrounded':
            return 0.5;
        case 'assistant':
            return 0.5;
        default:
            throw new Error('Invalid agent template');
    }
};

export const isAgentInProgress = (status: AgentStatus) => {
    return status !== AgentStatus.Created && status !== AgentStatus.Done;
};
